import React from 'react';
import ScheduleDateScrollMenu from '~/components/ScheduleDateScrollMenu/ScheduleDateScrollMenu';
import StyledComponent from '~/components/Styled/Styled';

import css from './Schedule.scss';

interface Props {
  data: {};
  selected: boolean;
}

class Schedule extends React.Component<Props> {
  static displayName = 'Schedule';

  render() {
    return (
      <div>
        <div className={css.sticky}>
          <div className={css.maxWidth}>
            <ScheduleDateScrollMenu
              graphQL
              height="38px"
              items={this.props.data}
              initialSelected={this.props.selected}
            />
          </div>
        </div>
        <div className={css.keepHeight} />
      </div>
    );
  }
}

export default StyledComponent(Schedule, [css]);
